import type { CostCenters } from "@/apis/gql/types";
import { useTenant } from "@/providers/session";
import { gql, useMutation } from "@apollo/client";
import { noop } from "lodash";
import { COST_CENTERS_QUERY } from "./fetch";

export const useCreateCostCenters = () => {
  const { tenantId } = useTenant();
  const [creatCostCenter, { data, loading, error }] = useMutation(
    CREATE_COST_CENTER_MUTATION,
    {
      refetchQueries: [COST_CENTERS_QUERY],
    },
  );

  const handleCreateCostCenter = async (
    data: Partial<CostCenters>,
    onSuccess: () => void = noop,
    onError: () => void = noop,
  ) => {
    await creatCostCenter({
      variables: { costCenter: data },
      update: (cache, { data: { createCostCenter } }) => {
        try {
          // Read the existing costCenters from the cache
          const existingData = cache.readQuery<{ costCenters: CostCenters[] }>({
            query: COST_CENTERS_QUERY,
            variables: { tenantId },
          });

          const existingCostCenters: CostCenters[] =
            existingData?.costCenters ?? [];

          const newData = {
            costCenters: [...existingCostCenters, createCostCenter],
          };

          cache.writeQuery({
            query: COST_CENTERS_QUERY,
            variables: { tenantId },
            data: newData,
          });
        } catch (error) {
          console.error(
            "Error updating cache after createCostCenter mutation:",
            error,
          );
        }
      },
    });
  };

  return {
    createCostCenter: handleCreateCostCenter,
    data,
    loading,
    error,
  };
};

export const CREATE_COST_CENTER_MUTATION = gql`
  mutation CreateCostCenter($costCenter: CostCenterInput!) {
    createCostCenter(costCenter: $costCenter) {
      costCenterId
      name
      description
      identifier
    }
  }
`;
